<template>
  <div>
    <div class="text-right">
      <BaseButton v-if="task.publishedAt" danger :disabled="loading" @click="unpublish">
        UnPublish
      </BaseButton>
      <BaseButton v-else success :disabled="loading || !isAssigned" @click="publish">
        Publish
      </BaseButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TaskPublish',
  props: {
    task: { type: Object, required: true },
  },
  data() {
    return {
      loading: false,
      failed: false,
    };
  },
  computed: {
    isAssigned() {
      return typeof this.task.userAssignedId === 'string';
    },
  },
  methods: {
    async publish() {
      try {
        this.loading = true;

        await this.$store.dispatch({
          type: 'ui/tasks/publish',
          formData: { taskId: this.task.uuid },
        });
      } catch (error) {
        this.failed = true;
      } finally {
        this.loading = false;
      }
    },
    async unpublish() {
      try {
        this.loading = true;

        await this.$store.dispatch({
          type: 'ui/tasks/unpublish',
          taskId: this.task.uuid,
        });
      } catch (error) {
        this.failed = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
